module.exports = __webpack_public_path__ + "static/media/bomb.54ce483b.mp3";